import React from 'react'

import style from '../Globals.module.scss'

const Questions = () => {
	return (
		<section className='body-content'>
			<div className='wrapper'>
				<h1 className={style.heading}>Câu hỏi thường gặp</h1>
				<p className={style.step}>
					1/ Tôi sẽ nhận được tiền hoàn trả trong bao lâu?
				</p>
				<p className={style.step}>
					ND Mall sẽ tiến hành hoàn tiền đến quý khách ngay sau khi quy trình
					kiểm tra đánh giá chất lượng sản phẩm đổi/trả hoàn tất. Quy trình này
					có thể cần khoảng 3 ngày làm việc. Thông tin về thời gian hoàn tiền cụ
					thể cho từng trường hợp đổi/ trả sẽ được cập nhật đến quý khách qua
					email hoặc thông báo trong tài khoản.
				</p>
				<p className={style.step}>
					Quý khách có thể tham khảo thông tin thời gian hoàn tiền như sau:
				</p>
				<p className={style.step}>
					(*) Lưu ý: <br />
					- Đối với thẻ Visa/Master/ JCB, số tiền được ngân hàng chuyển vào tài
					khoản quý khách sẽ dao động 1-3 tuần làm việc (tùy theo chính sách của
					từng ngân hàng). <br />
					- Ngày làm việc không bao gồm T7, CN và ngày lễ. <br />
					- Với đơn hàng đã được thanh toán bằng tiền mặt: ND Mall tiến hành
					hoàn tiền theo phương thức chuyển khoản hoặc ND Mall Xu sau khi nhận
					được sản phẩm trả về của khách hàng. <br />
					- Với đơn hàng đã được thanh toán online qua thẻ ngân hàng/ ví điện
					tử: ND Mall sẽ hoàn tiền vào thẻ/ ví mà quý khách đã sử dụng khi thanh
					toán. <br />
					2/ Tôi phải đóng gói sản phẩm đổi trả, bảo hành như thế nào?
				</p>
				<p className={style.step}>
					Nhằm đảm bảo an toàn cho sản phẩm khi gửi về ND Mall , quý khách vui
					lòng thực hiện đóng gói sản phẩm theo hướng dẫn sau:
				</p>
				<p className={style.step}>Bước 1: Đóng gói sản phẩm trong hộp.</p>
				<p className={style.step}>
					- Quý khách nên dùng hộp, thùng carton có kích thước lớn hơn sản phẩm
					để đóng gói.
				</p>
				<p className={style.step}>
					- Trường hợp đổi/trả sản phẩm thuộc 2 đơn hàng khác nhau, quý khách
					vui lòng đóng gói riêng kiện hàng để tránh nhầm lẫn trong quá trình ND
					Mall xử lý.
				</p>
				<p className={style.step}>
					- Đối với sản phẩm đã qua sử dụng, quý khách cần vệ sinh sản phẩm
					trước khi đóng gói.
				</p>
				<p className={style.step}>Bước 2: Đóng gói phụ kiện kèm theo.</p>
				<p className={style.step}>
					- Phụ kiện/linh kiện sản phẩm cần được gói riêng hoặc quấn băng keo
					tránh thất lạc.
				</p>
				<p className={style.step}>
					- Quý khách vui lòng gửi kèm hóa đơn hoặc quà tặng khuyến mãi kèm theo
					(nếu có).
				</p>
				<p className={style.step}>Bước 3: Chèn lót, bọc kín sản phẩm.</p>
				<p className={style.step}>
					- Đối với sản phẩm điện tử giá trị cao cần được đóng gói cẩn thận
					tránh bể vỡ trong quá trình vận chuyển, quý khách vui lòng tham khảo
					cách đóng gói sau:
				</p>
				<p className={style.step}>
					- Đối với sản phẩm dễ vỡ hoặc chất lỏng có thể rò rỉ, hư hại trong quá
					trình xử lý, để đóng gói các sản phẩm này, quý khách vui lòng thực
					hiện theo hướng dẫn sau:
				</p>
				<p className={style.step}>
					- Đối với sản phẩm sắc nhọn cần được bao gói lại các góc cạnh sắc
					nhọn, để đóng gói các sản phẩm này quý khách vui lòng tham khảo theo
					hướng dẫn sau:
				</p>
				<p className={style.step}>Bước 4: Hoàn tất đóng gói.</p>
				<p className={style.step}>
					- Quý khách lưu ý không dán băng keo trực tiếp lên hộp của sản phẩm.
				</p>
				<p className={style.step}>
					- Ghi chú thông tin bên ngoài hộp đóng gói: mã đơn hàng, mã yêu cầu
					đổi trả, mã thu hồi.
				</p>
				<p className={style.step}>Lưu ý:</p>
				<p className={style.step}>
					- ND Mall xin phép từ chối hỗ trợ những sản phẩm hoàn trả chưa được
					đóng gói theo hướng dẫn trên.
				</p>
				<p className={style.step}>
					- Quý khách cần quay video clip đóng gói sản phẩm để làm bằng chứng
					đối chiếu/ khiếu nại về sau (nếu cần).
				</p>
				<p className={style.step}>
					- Quý khách vui lòng gửi đúng sản phẩm và số lượng đã đăng ký. ND Mall
					không chịu trách nhiệm cho các sản phẩm ngoài nội dung đã ghi nhận
					trong yêu cầu đổi trả hàng.
				</p>
				<p className={style.step}>
					- Quý khách vui lòng gửi đúng sản phẩm và số lượng đã đăng ký. ND Mall
					không chịu trách nhiệm cho các sản phẩm ngoài nội dung đã ghi nhận
					trong yêu cầu đổi trả hàng.
				</p>
				<p className={style.step}>
					Bước 5: Bàn giao kiện hàng cho nhân viên thu hồi. <br />
					Quý khách vui lòng đối chiếu thông tin mã thu hồi với nhân viên vận
					chuyển trước khi đưa hàng để đảm bảo đúng kiện hàng.
				</p>
				<p className={style.step}>
					Để bảo vệ quyền lợi và tránh thất lạc hàng hóa, quý khách chỉ bàn giao
					kiện hàng cho nhân viên vận chuyển khi đảm bảo có 1 trong các điều
					kiện sau: <br />
					- Nhân viên vận chuyển cung cấp giấy xác nhận thu hồi. <br />- Nhân
					viên vận chuyển bấm xác nhận thu hồi thành công trên ứng dụng vận
					chuyển.
				</p>
				<p className={style.step}>3/ Trường hợp nào tôi được đổi sản phẩm?</p>
				<p className={style.step}>
					ND Mall chỉ đổi sản phẩm trong trường hợp sản phẩm bị lỗi không phát
					sinh từ phía khách hàng, cụ thể gồm những trường hợp dưới đây:
				</p>
				<p className={style.step}>
					Lỗi kỹ thuật của sản phẩm <br />
					Hàng hóa bị bể vỡ trước khi đến tay khách hàng. <br />
					Giao sai/ giao thiếu sản phẩm
				</p>
			</div>
		</section>
	)
}

export default Questions
